import React,
{
  useEffect,
  useState
} from "react";

import axios from "axios";

import {
  useNavigate,
  useParams
} from "react-router-dom";

import "./FoodItemDetails.css";

const BASE_API =
  process.env.BASE_API_URL ||
  "https://scanmymenu-nm38.onrender.com/api";

export default function FoodItemDetails() {

  const { itemId } =
    useParams();

  const navigate =
    useNavigate();

  const [item,
    setItem] =
    useState(null);

  const [loading,
    setLoading] =
    useState(true);

  // ==========================
  // FETCH ITEM
  // ==========================

  const fetchItem =
    React.useCallback(
      async () => {

        try {

          const res =
            await axios.get(
              `${BASE_API}/restaurants/items/${itemId}`
            );

          setItem(
            res.data
          );

        }

        catch (err) {

          console.log(err);

        }

        finally {

          setLoading(false);

        }

      },
      [itemId]
    );

  useEffect(() => {

    fetchItem();

  }, [fetchItem]);

  // ==========================
  // LOADING
  // ==========================

  if (loading) {

    return (

      <div className="food-loading">

        Loading...

      </div>

    );

  }

  if (!item) {

    return (

      <div className="food-loading">

        Food item not found

      </div>

    );

  }

  return (

    <div className="food-page">

      <div className="food-container">

        {/* BACK BUTTON */}

        <button
          className="back-btn"
          onClick={() =>
            navigate(-1)
          }
        >

          ← Back

        </button>

        {/* HERO IMAGE */}

        <div className="food-image-wrapper">

          <img
            src={item.imageUrl}
            alt={item.name}
            className="food-image"
          />

          <div className="food-overlay">

            <span className="food-category">

              {item.category}

            </span>

          </div>

        </div>

        {/* CONTENT */}

        <div className="food-content">

          {/* TOP */}

          <div className="food-top">

            <div>

              <h1>
                {item.name}
              </h1>

              <p className="food-type">

                {item.type || "Veg"}

              </p>

            </div>

            <div className="food-price">

              ₹ {item.price}

            </div>

          </div>

          {/* DESCRIPTION */}

          <p className="food-description">

            {
              item.description ||
              "No description available"
            }

          </p>

          {/* DETAILS GRID */}

          <div className="details-grid">

            <div className="detail-card">

              <span className="detail-label">

                Calories

              </span>

              <span className="detail-value">

                {
                  item.calories || "-"
                }

              </span>

            </div>

            <div className="detail-card">

              <span className="detail-label">

                Preparation Time

              </span>

              <span className="detail-value">

                {
                  item.prepTime || "-"
                }

              </span>

            </div>

            <div className="detail-card">

              <span className="detail-label">

                Category

              </span>

              <span className="detail-value">

                {
                  item.category || "-"
                }

              </span>

            </div>

            <div className="detail-card">

              <span className="detail-label">

                Food Type

              </span>

              <span className="detail-value">

                {
                  item.type || "-"
                }

              </span>

            </div>

          </div>

          {/* INGREDIENTS */}

<div className="ingredients-list">

  {
    (
      Array.isArray(
        item.ingredients
      )

        ? item.ingredients

        : String(
            item.ingredients || ""
          ).split(",")

    ).map(
      (ingredient, index) => (

        <span
          className="ingredient-tag"
          key={index}
        >

          {ingredient}

        </span>

      )
    )
  }

</div>

          {/* ACTIONS */}

          <div className="food-actions">

            {
              item.modelUrl && (

                <a
                  href={item.modelUrl}
                  target="_blank"
                  rel="noreferrer"
                  className="model-btn"
                >

                  View 3D Model

                </a>

              )
            }

            <button
              className="edit-btn"
              onClick={() =>
                navigate(
                  `/edit-item/${item.itemId}`
                )
              }
            >

              Edit Food Item

            </button>

          </div>

        </div>

      </div>

    </div>

  );

}